export enum DataFarmType {
    ingest,
    subTask,
    task,
    activity,
    cases,
    users,
    behaviors,
    master
}

export class DataFarmTypeUtil {
    static toString(type: DataFarmType): string {
        switch (type) {
            case DataFarmType.activity:
                return 'Activity';
            case DataFarmType.ingest:
                return 'Ingest';
            case DataFarmType.subTask:
                return 'Subtask';
            case DataFarmType.task:
                return 'Task';
            case DataFarmType.cases:
                return 'Cases';
            case DataFarmType.users:
                return 'User';
            case DataFarmType.behaviors:
                return 'Behaviors';
            case DataFarmType.master:
                return 'Master';
        }
    }
}
